import React, { useState } from 'react';
import { Box, Typography, Autocomplete, TextField, Tabs, Tab, Button, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { Download, ContentCopy } from '@mui/icons-material';
import CheckCircle from '@mui/icons-material/CheckCircle';
import SpinnerModal from './SpinnerModal';

const Nosql = () => {
  const [sourceSearch, setSourceSearch] = useState('');
  const [targetSearch, setTargetSearch] = useState('');
  const [sourceDb, setSourceDb] = useState('');
  const [targetDb, setTargetDb] = useState('');
  const [tabValue, setTabValue] = useState(0);
  const [jsonFileName, setJsonFileName] = useState('');
  const [jsonFile, setJsonFile] = useState(null); // Store the actual file
  const [progress, setProgress] = useState(0);
  const [showSpinnerModal, setShowSpinnerModal] = useState(false);
  const [apiResult, setApiResult] = useState(null);
  const [mappingFileName, setMappingFileName] = useState('');
  const [mappingFile, setMappingFile] = useState(null);
  const [showddlSpinnerModal, setShowddlSpinnerModal] = useState(false);
  const [reviewedDDLFileName, setReviewedDDLFileName] = useState('');
  const [reviewedMappingFileName, setReviewedMappingFileName] = useState('');
  const [showdatainsertSpinnerModal, setShowdatainsertlSpinnerModal] = useState(false); // New state for data insert spinner
  const [hostname, setHostname] = useState('');
  const [port, setPort] = useState('');
  const [dbname, setDbname] = useState('');
  const [user, setUser] = useState('');
  const [password, setPassword] = useState('');
  const [connectionStatus, setConnectionStatus] = useState(null); // null | 'success' | 'failed'
  const [mappingapiResult, setmappingapiResult] = useState(null); // For the "Generate DDL" button
  const [datainsertsqlapiResult, setdatainsertsqlapiResult] = useState(null); // For the "Generate Data Insertion SQL" button
  const [datainsertionsqlFileName, setdatainsertionSqlFileName] = useState(''); // New state for SQL file name
  const [dataInsertionMethod, setDataInsertionMethod] = useState(''); // New state for data insertion method
  const [datainsertionapiResult, setdatainsertionapiResult] = useState(null); // New state for data insertion API result
  const [reviewedDDLFile, setReviewedDDLFile] = useState(null); // Store the actual reviewed DDL file
  const [showpythonscriptSpinnerModal, setShowpythonscriptSpinnerModal] = useState(false);
  const [ddlGenerationCompleted, setDdlGenerationCompleted] = useState(false);
  const [dataInsertionSqlCompleted, setDataInsertionSqlCompleted] = useState(false);

  const sourceOptions = ['MongoDB'];
  const targetOptions = ['Postgres'];

  const targetDbOptions = ['Postgres',];

  const dropdownStyle = { width: '300px' };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleJsonUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setJsonFileName(file.name);
      setJsonFile(file); // Store the file for submission
    }
  };
   const getFileAccept = () => {
     if (sourceDb === 'MongoDB') return '.json';
     return '';
  };

  const handleGenerateMapping = async () => {
    if (!sourceDb || !targetDb || !jsonFile) {
      alert('Please select source, target, and upload a JSON file.');
      return;
    }

    const formData = new FormData();
    formData.append('file', jsonFile);
    let interval; // Declare interval outside the try block

    try {
      setSpinnerType('mapping');
      setShowSpinnerModal(true); // Show spinner modal
      setProgress(0); // Reset progress

      // Start progress simulation
      let interval=null;
      interval = setInterval(() => {
        setProgress((prevProgress) => {
          if (prevProgress >= 90) {
            clearInterval(interval); // Stop the interval when progress reaches 100%
            return 90;
          }
          return prevProgress + 10; // Increment progress by 10%
        });
      }, 30000); // Update progress every 24 seconds (24000 ms)

      // Upload the file to S3
      const uploadResponse = await fetch('https://api.elevate.de.ltim.io/file_upload_for_nosql_to_rdbms/', {
        method: 'POST',
        body: formData,
      });

      if (!uploadResponse.ok) {
        const errorData = await uploadResponse.json();
        alert(`File upload failed: ${errorData.detail}`);
        clearInterval(interval); // Stop progress simulation
        setShowSpinnerModal(false); // Hide spinner modal
        return;
      }

      const uploadResult = await uploadResponse.json();
      const uploadedFileName = uploadResult.filename;

      // Send the source, target, uploaded file name, and file_type to the backend
      const payload = {
        source: sourceDb,
        target: targetDb,
        file_name: uploadedFileName,
      };

      const response = await fetch('https://api.elevate.de.ltim.io/nosql_to_sql/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      clearInterval(interval); // Stop progress simulation when the response is received

      if (!response.ok) {
        const errorData = await response.json();
        alert(`Error processing file: ${errorData.detail}`);
        setShowSpinnerModal(false); // Hide spinner modal
        return;
      }

      const result = await response.json();
      setApiResult(result); // Store API result
      setProgress(100); // Set progress to 100% on success
      setTimeout(() => {
        setShowSpinnerModal(false); // Hide spinner modal after 5000 ms
        setTabValue(1); // Automatically switch to the "Result" tab
      }, 3000); // 
    } catch (error) {
      console.error('Error:', error);
      alert('An error occurred while processing the file.');
      clearInterval(interval); // Stop progress simulation
      setShowSpinnerModal(false); // Hide spinner modal
    }
  };

  const handleCopyCode = () => {
    if (!apiResult || !apiResult.report) {
      alert('No API result available to copy.');
      return;
    }

    const resultContent = String(apiResult.report);
    navigator.clipboard.writeText(resultContent).then(() => {
      alert('Result content copied to clipboard!');
    }).catch((error) => {
      console.error('Failed to copy text:', error);
    });
  };


  const handleFileUploadMappingCsv = async (event) => {
    const file = event.target.files[0];
    if (file) {
      setMappingFileName(file.name);
      setMappingFile(file);

      // Upload the file immediately after selection
      const formData = new FormData();
      formData.append('file', file);

      try {
        const uploadResponse = await fetch('https://api.elevate.de.ltim.io/file_upload_for_nosql_to_rdbms/', {
          method: 'POST',
          body: formData,
        });

        if (!uploadResponse.ok) {
          alert('Failed to upload the reviewed mapping CSV.');
          return;
        }

        // Optionally, you can handle the response here
      } catch (error) {
        alert('An error occurred while uploading the mapping CSV.');
      }
    }
  };

  const handleGenerateDdl = async () => {
    if (!mappingFileName) {
      alert('Please upload the reviewed mapping CSV first.');
      return;
    }

    // Only send the payload to generate DDL, do not upload file here
    const payload = {
      file_name: mappingFileName,
      ddl_file_name: "",
      source: "",
      target: "",
      is_json: false,
      is_csv: true,
      is_ddl: false,
      is_sql: false,
      is_python_script: false,
    };

    let interval;
    try {
      setSpinnerType('ddl');
      setShowddlSpinnerModal(true);
      setProgress(0);

      // Start progress simulation
      let interval = null;
      interval = setInterval(() => {
        setProgress((prevProgress) => {
          if (prevProgress >= 90) {
            clearInterval(interval);
            return 90;
          }
          return prevProgress + 10;
        });
      }, 24000);

      const response = await fetch('https://api.elevate.de.ltim.io/nosql_to_sql/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      clearInterval(interval);

      if (!response.ok) {
        const errorData = await response.json();
        alert(`Error generating DDL: ${errorData.detail}`);
        setShowddlSpinnerModal(false);
        return;
      }

      const result = await response.json();
      setmappingapiResult(result);
      setProgress(100);
      setTimeout(() => {
        setShowddlSpinnerModal(false);
        setTabValue(2); // Redirect to tab 2
      }, 3000);
    } catch (error) {
      alert('An error occurred while generating DDL.');
      clearInterval(interval);
      setShowddlSpinnerModal(false);
    }
  };

  const handleDownloadDDL = () => {
    if (!mappingapiResult || !mappingapiResult.links) {
      alert('No DDL link available to download.');
      return;
    }
    const anchor = document.createElement('a');
    anchor.href = mappingapiResult.links;
    anchor.target = '_self';
    anchor.download = '';
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };

  const handleFileUploadReviewedDdl = async (event) => {
    const file = event.target.files[0];
    if (file) {
      setReviewedDDLFileName(file.name);
      setReviewedDDLFile(file); // Store the actual file
      // Upload the file immediately after selection
      const formData = new FormData();
      formData.append('file', file);

      try {
        const uploadResponse = await fetch('https://api.elevate.de.ltim.io/file_upload_for_nosql_to_rdbms/', {
          method: 'POST',
          body: formData,
        });

        if (!uploadResponse.ok) {
          alert('Failed to upload the reviewed DDL.');
          return;
        }
        // Optionally, handle the response here
      } catch (error) {
        alert('An error occurred while uploading the reviewed DDL.');
      }
    }
  };

  const handleFileUploadReviewedMappingCsv = async (event) => {
    const file = event.target.files[0];
    if (file) {
      setReviewedMappingFileName(file.name);
      // Upload the file immediately after selection
      const formData = new FormData();
      formData.append('file', file);

      try {
        const uploadResponse = await fetch('https://api.elevate.de.ltim.io/file_upload_for_nosql_to_rdbms/', {
          method: 'POST',
          body: formData,
        });

        if (!uploadResponse.ok) {
          alert('Failed to upload the reviewed mapping CSV.');
          return;
        }
        // Optionally, handle the response here
      } catch (error) {
        alert('An error occurred while uploading the reviewed mapping CSV.');
      }
    }
  };

  const handleGenerateDataInsertSql = async () => {
    let interval;
    try {
      setSpinnerType('datainsert');
      setShowdatainsertlSpinnerModal(true);
      setProgress(0);

      // Start progress simulation
      let interval = null;
      interval = setInterval(() => {
        setProgress((prevProgress) => {
          if (prevProgress >= 90) {
            clearInterval(interval);
            return 90;
          }
          return prevProgress + 10;
        });
      }, 24000);

      // Prepare payload for backend
      const payload = {
        file_name: reviewedMappingFileName,
        ddl_file_name: reviewedDDLFileName,
        source: "",
        target: "",
        is_json: false,
        is_csv: true,
        is_ddl: true,
        is_sql: false,
        is_python_script: false,
      };

      const response = await fetch('https://api.elevate.de.ltim.io/nosql_to_sql/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      clearInterval(interval);

      if (!response.ok) {
        const errorData = await response.json();
        alert(`Error generating Data Insert SQL: ${errorData.detail}`);
        setShowdatainsertlSpinnerModal(false);
        return;
      }

      const result = await response.json();
      setdatainsertsqlapiResult(result); // Store the result for display/download
      setProgress(100);
      setTimeout(() => {
        setShowdatainsertlSpinnerModal(false);
        setTabValue(3); // Redirect to tab 3
      }, 2000);
    } catch (error) {
      clearInterval(interval);
      setShowdatainsertlSpinnerModal(false);
    }
  };

  const handleDownloadDataInsertSql = () => {
    if (!datainsertsqlapiResult || !datainsertsqlapiResult.links) {
      alert('No Data Insert SQL link available to download.');
      return;
    }
    const anchor = document.createElement('a');
    anchor.href = datainsertsqlapiResult.links;
    anchor.target = '_self';
    anchor.download = '';
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };

  const handleValidateConnection = async () => {
    if (!targetDb || !hostname || !port || !dbname || !user || !password) {
      alert('Please fill in all required fields.');
      return;
    }

    const payload = {
      target: targetDb,
      target_config: {
        host: hostname,
        port: port,
        dbname: dbname,
        user: user,
        password: password,
      },
      is_nosql_to_sql: true,
    };

    try {
      // Replace with your actual backend endpoint
      const response = await fetch('https://api.elevate.de.ltim.io/db_config/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        setConnectionStatus('failed');
        return;
      }

      const result = await response.json();
      if (result.is_valid === true) {
        setConnectionStatus('success');
      } else {
        setConnectionStatus('failed');
      }
    } catch (error) {
      setConnectionStatus('failed');
    }
  };

  // Add this function to handle mapping download
  const handleDownloadMapping = () => {
    if (!apiResult || !apiResult.links || apiResult.links.length === 0) {
      alert('No mapping file link available to download.');
      return;
    }
    // Download the first mapping link (adjust if you want a specific one)
    const anchor = document.createElement('a');
    anchor.href = apiResult.links[0];
    anchor.target = '_self';
    anchor.download = '';
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
  };

  // New function to handle SQL file upload
  const handledatainsertionFileUpload = async (event) => {
    const file = event.target.files[0];
    if (file) {
      setdatainsertionSqlFileName(file.name);

      // Upload the SQL file immediately after selection
      const formData = new FormData();
      formData.append('file', file);

      try {
        const uploadResponse = await fetch('https://api.elevate.de.ltim.io/file_upload_for_nosql_to_rdbms/', {
          method: 'POST',
          body: formData,
        });

        if (!uploadResponse.ok) {
          alert('Failed to upload the SQL file.');
          return;
        }

        // Optionally, handle the response here
      } catch (error) {
        alert('An error occurred while uploading the SQL file.');
      }
    }
  };

  // New function to handle data insertion
  const handleDataInsertion = async () => {
    if (!dataInsertionMethod) {
      alert('Please select a data insertion method.');
      return;
    }
    if (!datainsertionsqlFileName) {
      alert('Please upload the Data Insertion SQL file.');
      return;
    }
    if (!jsonFile) {
      alert('Please upload the JSON file.');
      return;
    }
    if (!reviewedDDLFile) {
      alert('Please upload the reviewed DDL file.');
      return;
    }

    let uploadedDDLFileName = '';
    let uploadedJsonFileName = '';

    try {
      // Upload reviewed DDL file
      const ddlFormData = new FormData();
      ddlFormData.append('file', reviewedDDLFile); // Use the File object

      const ddlUploadResponse = await fetch('https://api.elevate.de.ltim.io/file_upload_for_nosql_to_rdbms/', {
        method: 'POST',
        body: ddlFormData,
      });
      if (!ddlUploadResponse.ok) {
        alert('Failed to upload the reviewed DDL file.');
        return;
      }
      const ddlUploadResult = await ddlUploadResponse.json();
      uploadedDDLFileName = ddlUploadResult.filename;

      // Upload JSON file
      const jsonFormData = new FormData();
      jsonFormData.append('file', jsonFile);

      const jsonUploadResponse = await fetch('https://api.elevate.de.ltim.io/file_upload_for_nosql_to_rdbms/', {
        method: 'POST',
        body: jsonFormData,
      });
      if (!jsonUploadResponse.ok) {
        alert('Failed to upload the JSON file.');
        return;
      }
      const jsonUploadResult = await jsonUploadResponse.json();
      uploadedJsonFileName = jsonUploadResult.filename;

      // Now send the payload with the new filenames
      const payload = {
        file_name: datainsertionsqlFileName,
        ddl_file_name: uploadedDDLFileName,
        json_file_name: uploadedJsonFileName,
        source: "",
        target: "",
        is_json: false,
        is_csv: false,
        is_ddl: false,
        is_sql: true,
        is_python_script: dataInsertionMethod === 'python',
      };

      let interval;
      if (dataInsertionMethod === 'python') {
        setSpinnerType('python');
        setShowpythonscriptSpinnerModal(true); // Show Python script spinner
      } else {
        setSpinnerType('datainsert');
        setShowdatainsertlSpinnerModal(true); // Show Data Insertion spinner
      }
      setProgress(0);

      interval = setInterval(() => {
        setProgress((prevProgress) => {
          if (prevProgress >= 90) {
            clearInterval(interval);
            return 90;
          }
          return prevProgress + 10;
        });
      }, 24000);

      const response = await fetch('https://api.elevate.de.ltim.io/nosql_to_sql/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      clearInterval(interval);

      if (!response.ok) {
        const errorData = await response.json();
        alert(`Error during data insertion: ${errorData.detail}`);
        setShowpythonscriptSpinnerModal(false);
        setShowdatainsertlSpinnerModal(false);
        return;
      }

      const result = await response.json();
      setdatainsertionapiResult(result);
      setProgress(100);
      setTimeout(() => {
        setShowpythonscriptSpinnerModal(false);
        setShowdatainsertlSpinnerModal(false);
        setTabValue(5); // Redirect to Result tab
      }, 2000);
    } catch (error) {
      setShowpythonscriptSpinnerModal(false);
      setShowdatainsertlSpinnerModal(false);
      alert('An error occurred during data insertion.');
    }
  };

  // New function to handle radio button change for data insertion method
  const handleRadioChange = (event) => {
    setDataInsertionMethod(event.target.value);
  };

  React.useEffect(() => {
    if (mappingapiResult && tabValue === 1) {
      setTimeout(() => setTabValue(2), 3000); // Switch to DDL Generation tab after 3 seconds
    }
  }, [mappingapiResult]);

  // When datainsertsqlapiResult is received, mark DDL Generation as completed and switch tab
  React.useEffect(() => {
    if (datainsertsqlapiResult && tabValue === 2) {
      setDdlGenerationCompleted(true);
      setTimeout(() => setTabValue(3), 1000); // Switch to Data Insertion SQL tab after 1s
    }
  }, [datainsertsqlapiResult]);

  // When Data Insertion tab is clicked, mark Data Insertion SQL as completed
  React.useEffect(() => {
    if (tabValue === 4) {
      setDataInsertionSqlCompleted(true);
    }
  }, [tabValue]);

  const [spinnerType, setSpinnerType] = useState('');

  const getSpinnerMessages = () => {
    switch (spinnerType) {
      case 'mapping':
        return {
          inProgress: 'Mapping is being generated...',
          success: 'Mapping Generated Successfully!',
          open: showSpinnerModal,
          onClose: () => setShowSpinnerModal(false),
        };
      case 'ddl':
        return {
          inProgress: 'DDL is being generated...',
          success: 'DDL Generated Successfully!',
          open: showddlSpinnerModal,
          onClose: () => setShowddlSpinnerModal(false),
        };
      case 'datainsert':
        return {
          inProgress: 'Data insertion is being generated...',
          success: 'Data insertion generated successfully!',
          open: showdatainsertSpinnerModal,
          onClose: () => setShowdatainsertlSpinnerModal(false),
        };
      case 'python':
        return {
          inProgress: 'Python script is being generated...',
          success: 'Python script generated successfully!',
          open: showpythonscriptSpinnerModal,
          onClose: () => setShowpythonscriptSpinnerModal(false),
        };
      default:
        return {};
    }
  };

  const spinnerMessages = getSpinnerMessages();

  return (
    <Box sx={{ width: '100%', marginTop: -7 }}>
      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        sx={{
          pl: 0,
          '& .MuiTabs-flexContainer': { justifyContent: 'flex-start' },
          '& .MuiTab-root': {
            minWidth: 120,
            fontWeight: 'bold',
            textTransform: 'none',
            paddingRight: 0,
            pl: 0,
          },
        }}
        TabIndicatorProps={{ style: { display: 'none' } }}
      >
        {/* Input Tab */}
        <Tab
          label={
            <Box display="flex" alignItems="center">
              {/* 1 Input */}
              <Box display="flex" alignItems="center">
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  width={24}
                  height={24}
                  borderRadius="50%"
                  bgcolor={apiResult?.report ? "#4caf50" : (tabValue === 0 ? "#1976d2" : "white")}
                  border="1.5px solid"
                  borderColor={apiResult?.report ? "#4caf50" : (tabValue === 0 ? "#1976d2" : "black")}
                  mr={1}
                  transition="all 0.2s"
                >
                  {apiResult?.report ? (
                    <CheckCircle sx={{ color: "white", fontSize: 20 }} />
                  ) : (
                    <Typography variant="subtitle2" sx={{ color: tabValue === 0 ? "white" : "black", fontWeight: 600 }}>1</Typography>
                  )}
                </Box>
                <Typography
                  sx={{
                    fontWeight: tabValue === 0 ? 700 : 400,
                    color: tabValue === 0 ? "primary.main" : "black",
                    userSelect: "none",
                    transition: "all 0.2s"
                  }}
                >
                  Input
                </Typography>
              </Box>
              {/* Arrow */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  height: 4,
                  ml: 1,
                  mr: 1,
                  mb: 0.6,
                }}
              >
                <Typography sx={{ color: "#bdbdbd", fontWeight: 700, fontSize: 30, lineHeight: 1 }}>
                  &rarr;
                </Typography>
              </Box>
            </Box>
          }
          disableRipple
          style={{ minWidth: 0, paddingRight: 0, paddingLeft: 0 }}
        />

        {/* Mapping Tab */}
        <Tab
          label={
            <Box display="flex" alignItems="center">
              {/* 2 Mapping */}
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                width={24}
                height={24}
                borderRadius="50%"
                bgcolor={mappingapiResult?.report ? "#4caf50" : (tabValue === 1 ? "#1976d2" : "white")}
                border="1.5px solid"
                borderColor={mappingapiResult?.report ? "#4caf50" : (tabValue === 1 ? "#1976d2" : "black")}
                mr={1}
                transition="all 0.2s"
              >
                {mappingapiResult?.report ? (
                  <CheckCircle sx={{ color: "white", fontSize: 20 }} />
                ) : (
                  <Typography variant="subtitle2" sx={{ color: tabValue === 1 ? "white" : "black", fontWeight: 600 }}>2</Typography>
                )}
              </Box>
              <Typography
                sx={{
                  fontWeight: tabValue === 1 ? 700 : 400,
                  color: tabValue === 1 ? "primary.main" : "black",
                  userSelect: "none",
                  transition: "all 0.2s"
                }}
              >
                Mapping
              </Typography>
              {/* Arrow */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  height: 4,
                  ml: 1,
                  mr: 1,
                  mb: 0.6,
                }}
              >
                <Typography sx={{ color: "#bdbdbd", fontWeight: 700, fontSize: 30, lineHeight: 1 }}>
                  &rarr;
                </Typography>
              </Box>
            </Box>
          }
          disableRipple
          style={{ minWidth: 0, paddingLeft: 0, paddingRight: 0 }}
        />

        {/* DDL Generation Tab */}
        <Tab
          label={
            <Box display="flex" alignItems="center">
              {/* 3 DDL Generation */}
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                width={24}
                height={24}
                borderRadius="50%"
                bgcolor={ddlGenerationCompleted ? "#4caf50" : (tabValue === 2 ? "#1976d2" : "white")}
                border="1.5px solid"
                borderColor={ddlGenerationCompleted ? "#4caf50" : (tabValue === 2 ? "#1976d2" : "black")}
                mr={1}
                transition="all 0.2s"
              >
                {ddlGenerationCompleted ? (
                  <CheckCircle sx={{ color: "white", fontSize: 20 }} />
                ) : (
                  <Typography variant="subtitle2" sx={{ color: tabValue === 2 ? "white" : "black", fontWeight: 600 }}>3</Typography>
                )}
              </Box>
              <Typography
                sx={{
                  fontWeight: tabValue === 2 ? 700 : 400,
                  color: tabValue === 2 ? "primary.main" : "black",
                  userSelect: "none",
                  transition: "all 0.2s"
                }}
              >
                DDL Generation
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  height: 4,
                  ml: 1,
                  mr: 1,
                  mb: 0.6,
                }}
              >
                <Typography sx={{ color: "#bdbdbd", fontWeight: 700, fontSize: 30, lineHeight: 1 }}>
                  &rarr;
                </Typography>
              </Box>
            </Box>
          }
          disableRipple
          style={{ minWidth: 0, paddingLeft: 0, paddingRight: 0 }}
        />

        {/* Data Insertion SQL Tab */}
        <Tab
          label={
            <Box display="flex" alignItems="center">
              {/* 4 Data Insertion SQL */}
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                width={24}
                height={24}
                borderRadius="50%"
                bgcolor={dataInsertionSqlCompleted ? "#4caf50" : (tabValue === 3 ? "#1976d2" : "white")}
                border="1.5px solid"
                borderColor={dataInsertionSqlCompleted ? "#4caf50" : (tabValue === 3 ? "#1976d2" : "black")}
                mr={1}
                transition="all 0.2s"
              >
                {dataInsertionSqlCompleted ? (
                  <CheckCircle sx={{ color: "white", fontSize: 20 }} />
                ) : (
                  <Typography variant="subtitle2" sx={{ color: tabValue === 3 ? "white" : "black", fontWeight: 600 }}>4</Typography>
                )}
              </Box>
              <Typography
                sx={{
                  fontWeight: tabValue === 3 ? 700 : 400,
                  color: tabValue === 3 ? "primary.main" : "black",
                  userSelect: "none",
                  transition: "all 0.2s"
                }}
              >
                Data Insertion SQL
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  height: 4,
                  ml: 1,
                  mr: 1,
                  mb: 0.6,
                }}
              >
                <Typography sx={{ color: "#bdbdbd", fontWeight: 700, fontSize: 30, lineHeight: 1 }}>
                  &rarr;
                </Typography>
              </Box>
            </Box>
          }
          disableRipple
          style={{ minWidth: 0, paddingLeft: 0, paddingRight: 0 }}
        />

        {/* Data Insertion Tab */}
        <Tab
          label={
            <Box display="flex" alignItems="center">
              {/* 5 Data Insertion */}
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                width={24}
                height={24}
                borderRadius="50%"
                bgcolor={datainsertionapiResult?.report ? "#4caf50" : tabValue === 4 ? "#1976d2" : "white"}
                border="1.5px solid"
                borderColor={datainsertionapiResult?.report ? "#4caf50" : tabValue === 4 ? "#1976d2" : "black"}
                mr={1}
                transition="all 0.2s"
              >
                {datainsertionapiResult?.report ? (
                  <CheckCircle sx={{ color: "white", fontSize: 20 }} />
                ) : (
                  <Typography variant="subtitle2" sx={{ color: tabValue === 4 ? "white" : "black", fontWeight: 600 }}>5</Typography>
                )}
                </Box>
              <Typography
                sx={{
                  fontWeight: tabValue === 4 ? 700 : 400,
                  color: tabValue === 4 ? "primary.main" : "black",
                  userSelect: "none",
                  transition: "all 0.2s"
                }}
              >
                Data Insertion
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  height: 4,
                  ml: 1,
                  mr: 1,
                  mb: 0.6,
                }}
              >
                <Typography sx={{ color: "#bdbdbd", fontWeight: 700, fontSize: 30, lineHeight: 1 }}>
                  &rarr;
                </Typography>
              </Box>
            </Box>
          }
          disableRipple
          style={{ minWidth: 0, paddingLeft: 0, paddingRight: 0 }}
        />

        {/* Result Tab */}
        <Tab
          label={
            <Box display="flex" alignItems="center">
              {/* 6 Result */}
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                width={24}
                height={24}
                borderRadius="50%"
                bgcolor={tabValue === 5 ? "#1976d2" : "white"}
                border="1.5px solid"
                borderColor={tabValue === 5 ? "#1976d2" : "black"}
                mr={1}
                transition="all 0.2s"
              >
                <Typography variant="subtitle2" sx={{ color: tabValue === 5 ? "white" : "black", fontWeight: 600 }}>6</Typography>
              </Box>
              <Typography
                sx={{
                  fontWeight: tabValue === 5 ? 700 : 400,
                  color: tabValue === 5 ? "primary.main" : "black",
                  userSelect: "none",
                  transition: "all 0.2s"
                }}
              >
                Result
              </Typography>
            </Box>
          }
          disableRipple
          style={{ minWidth: 0, paddingLeft: 0, paddingRight: 0 }}
        />
      </Tabs>

      {tabValue === 0 && (
        <Box sx={{ marginTop: 2 }}>
          {/* Input Section */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              alignItems: 'flex-start',
              justifyContent: 'space-between',
              width: '100%',
              gap: 2,
            }}
          >
            <Box sx={{ maxWidth: '300px' }}>
              <Typography variant="subtitle1" id="source-label" sx={{ fontWeight: 'bold' }}>
                Source<span style={{ color: 'red' }}>*</span>
              </Typography>
              <Autocomplete
                options={sourceOptions}
                value={sourceDb || ''}
                onChange={(event, newValue) => setSourceDb(newValue || '')}
                inputValue={sourceSearch}
                onInputChange={(event, newInputValue) => setSourceSearch(newInputValue)}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Select Source" variant="outlined" size="small" />
                )}
                sx={dropdownStyle}
              />

              <Box sx={{ marginTop: 2 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', marginBottom: 1 }}>
                  Please upload JSON file<span style={{ color: 'red' }}>*</span>
                </Typography>
                <Button
                  variant="contained"
                  color="primary"
                  component="label"
                  sx={{
                    backgroundColor: 'white',
                    color: 'black',
                    border: '1px solid black',
                    boxShadow: 'none',
                    height: '40px',
                  }}
                >
                  Upload JSON
                  <input type="file" hidden 
                  accept={getFileAccept()} 
                  onChange={handleJsonUpload} />
                </Button>
                {jsonFileName && (
                  <>
                    <Typography
                      variant="body2"
                      sx={{ marginTop: 1, color: 'green', fontWeight: 'bold' }}
                    >
                      Uploaded File: {jsonFileName}
                    </Typography>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleGenerateMapping}
                      sx={{
                        marginTop: 2,
                        backgroundColor: 'white',
                        color: 'black',
                        border: '1px solid black',
                        boxShadow: 'none',
                        height: '40px',
                      }}
                    >
                      Generate Mapping
                    </Button>
                  </>
                )}
              </Box>
            </Box>

            <Box sx={{ maxWidth: '300px', marginRight: '150px' }}>
              <Typography variant="subtitle1" id="target-label" sx={{ fontWeight: 'bold' }}>
                Target<span style={{ color: 'red' }}>*</span>
              </Typography>
              <Autocomplete
                options={targetOptions}
                value={targetDb || ''}
                onChange={(event, newValue) => setTargetDb(newValue || '')}
                inputValue={targetSearch}
                onInputChange={(event, newInputValue) => setTargetSearch(newInputValue)}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Select Target" variant="outlined" size="small" />
                )}
                sx={dropdownStyle}
              />
            </Box>
          </Box>
        </Box>
      )}

      {tabValue === 1 && (
        <Box sx={{ marginTop: 2 }}>
          <Box
            sx={{
              marginTop: 4,
              padding: '16px',
              backgroundColor: '#f9f9f9',
              borderRadius: '8px',
              border: '1px solid #ccc',
              marginBottom: 2,
            }}
          >
            <Typography variant="h6" sx={{ marginBottom: 2 }}>
              Output
            </Typography>
            {apiResult ? (
              <Typography
                variant="body1"
                sx={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace' }}
              >
                {String(apiResult.report)}
              </Typography>
            ) : (
              <Typography variant="body2">No result available</Typography>
            )}
          </Box>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              gap: 2,
              marginTop: 2,
            }}
          >
            {/* Mapping CSV Download/Upload Section */}
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  fontWeight: 'bold',
                  color: '#333',
                  marginBottom: 1,
                }}
              >
                Please Download and Review the Mapping CSV
              </Typography>

              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                }}
              >
                {apiResult?.links?.length > 0 && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleDownloadMapping}
                    sx={{
                      backgroundColor: 'white',
                      color: 'black',
                      border: '1px solid black',
                      boxShadow: 'none',
                    }}
                    startIcon={<Download />}
                  >
                    Download Mapping
                  </Button>
                )}

                {/* Upload Section */}
                <Box sx={{ marginTop: 2 }}>
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 'bold',
                      color: '#333',
                      marginBottom: 1,
                    }}
                  >
                    Please upload the reviewed mapping CSV
                  </Typography>
                  <Button
                    variant="contained"
                    color="primary"
                    component="label"
                    sx={{
                      backgroundColor: 'white',
                      color: 'black',
                      border: '1px solid black',
                      boxShadow: 'none',
                    }}
                  >
                    Upload File
                    <input
                      type="file"
                      hidden
                      onChange={handleFileUploadMappingCsv}
                    />
                  </Button>
                  {mappingFileName && (
                    <>
                      <Typography
                        variant="body2"
                        sx={{ marginTop: 1, color: 'green', fontWeight: 'bold' }}
                      >
                        Uploaded File: {mappingFileName}
                      </Typography>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleGenerateDdl}
                        sx={{
                          marginTop: 2,
                          backgroundColor: 'white',
                          color: 'black',
                          border: '1px solid black',
                          boxShadow: 'none',
                          height: '40px',
                        }}
                      >
                        Generate Ddl
                      </Button>
                    </>
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      )}

      {tabValue === 2 && (
        <Box sx={{ marginTop: 2 }}>
          <Box
            sx={{
              marginTop: 4,
              padding: '16px',
              backgroundColor: '#f9f9f9',
              borderRadius: '8px',
              border: '1px solid #ccc',
              marginBottom: 2,
            }}
          >
            <Typography variant="h6" sx={{ marginBottom: 2 }}>
              Output
            </Typography>
            {mappingapiResult?.report ? (
              <Typography
                variant="body1"
                sx={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace' }}
              >
                {String(mappingapiResult.report)}
              </Typography>
            ) : (
              <Typography variant="body2">No result available</Typography>
            )}
          </Box>

          {/* DDL Download Section */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              marginTop: 2,
            }}
          >
            <Typography
              variant="body1"
              sx={{
                fontWeight: 'bold',
                color: '#333',
                marginBottom: 1,
              }}
            >
              Please download and review DDL
            </Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={handleDownloadDDL}
              sx={{
                backgroundColor: 'white',
                color: 'black',
                border: '1px solid black',
                boxShadow: 'none',
              }}
              startIcon={<Download />}
            >
              Download DDL
            </Button>
          </Box>

          {/* Upload reviewed DDL Section */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              marginTop: 3,
            }}
          >
            <Typography
              variant="body1"
              sx={{
                fontWeight: 'bold',
                color: '#333',
                marginBottom: 1,
              }}
            >
              Please upload the reviewed DDL
            </Typography>
            <Button
              variant="contained"
              color="primary"
              component="label"
              sx={{
                backgroundColor: 'white',
                color: 'black',
                border: '1px solid black',
                boxShadow: 'none',
              }}
            >
              Upload DDL
              <input
                type="file"
                hidden
                onChange={handleFileUploadReviewedDdl}
              />
            </Button>
            {reviewedDDLFileName && (
              <Typography
                variant="body2"
                sx={{ marginTop: 1, color: 'green', fontWeight: 'bold' }}
              >
                Uploaded File: {reviewedDDLFileName}
              </Typography>
            )}
          </Box>

          {/* Upload reviewed mapping CSV Section */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              marginTop: 3,
            }}
          >
            <Typography
              variant="body1"
              sx={{
                fontWeight: 'bold',
                color: '#333',
                marginBottom: 1,
              }}
            >
              Please upload the reviewed mapping CSV
            </Typography>
            <Button
              variant="contained"
              color="primary"
              component="label"
              sx={{
                backgroundColor: 'white',
                color: 'black',
                border: '1px solid black',
                boxShadow: 'none',
              }}
            >
              Upload Mapping CSV
              <input
                type="file"
                hidden
                onChange={handleFileUploadReviewedMappingCsv}
              />
            </Button>
            {reviewedMappingFileName && (
              <Typography
                variant="body2"
                sx={{ marginTop: 1, color: 'green', fontWeight: 'bold' }}
              >
                Uploaded File: {reviewedMappingFileName}
              </Typography>
            )}
          </Box>

          {/* Generate Data Insertion SQL Section */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              marginTop: 3,
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={handleGenerateDataInsertSql}
              sx={{
                backgroundColor: 'white',
                color: 'black',
                border: '1px solid black',
                boxShadow: 'none',
                height: '40px',
              }}
            >
              Generate Data Insertion SQL
            </Button>
          </Box>
        </Box>
      )}

      {tabValue === 3 && (
        <Box sx={{ marginTop: 2 }}>
          <Box
            sx={{
              marginTop: 4,
              padding: '16px',
              backgroundColor: '#f9f9f9',
              borderRadius: '8px',
              border: '1px solid #ccc',
              marginBottom: 2,
            }}
          >
            <Typography variant="h6" sx={{ marginBottom: 2 }}>
              Data Insertion SQL
            </Typography>
            {datainsertsqlapiResult ? (
              <Typography
                variant="body1"
                sx={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace' }}
              >
                {String(datainsertsqlapiResult.report)}
              </Typography>
            ) : (
              <Typography variant="body2">No SQL script available</Typography>
            )}
          </Box>

          {/* Download and review Data Insert SQL Button */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              marginTop: 2,
            }}
          >
            <Typography
              variant="body1"
              sx={{
                fontWeight: 'bold',
                color: '#333',
                marginBottom: 1,
              }}
            >
              Please download and review data insert sql
            </Typography>
            <Button
              variant="contained"
              color="primary"
              onClick={handleDownloadDataInsertSql}
              sx={{
                backgroundColor: 'white',
                color: 'black',
                border: '1px solid black',
                boxShadow: 'none',
              }}
              startIcon={<Download />}
            >
              Download Data Insert SQL
            </Button>
          </Box>
          <Typography
            variant="body1"
            sx={{
              marginTop: 2,
              fontWeight: 'bold',
              color: '#333',
            }}
          >
            Please proceed to the next tab for actual data insertion.
          </Typography>
        </Box>
      )}

      {tabValue === 4 && (
        <Box sx={{ marginTop: 2, maxWidth: 350 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 'bold', marginBottom: 1 }}>
            Target Database<span style={{ color: 'red' }}>*</span>
          </Typography>
          <Autocomplete
            options={targetDbOptions}
            value={targetDb || ''}
            onChange={(event, newValue) => setTargetDb(newValue || '')}
            inputValue={targetSearch}
            onInputChange={(event, newInputValue) => setTargetSearch(newInputValue)}
            renderInput={(params) => (
              <TextField {...params} placeholder="Select Target" variant="outlined" size="small" />
            )}
            sx={{ width: '100%', marginBottom: 2 }}
          />

          <TextField
            label="Hostname"
            variant="outlined"
            size="small"
            fullWidth
            sx={{ marginBottom: 2 }}
            value={hostname}
            onChange={(e) => setHostname(e.target.value)}
          />
          <TextField
            label="Port"
            variant="outlined"
            size="small"
            fullWidth
            sx={{ marginBottom: 2 }}
            value={port}
            onChange={(e) => setPort(e.target.value)}
          />
          <TextField
            label="dbname"
            variant="outlined"
            size="small"
            fullWidth
            sx={{ marginBottom: 2 }}
            value={dbname}
            onChange={(e) => setDbname(e.target.value)}
          />
          <TextField
            label="User"
            variant="outlined"
            size="small"
            fullWidth
            sx={{ marginBottom: 2 }}
            value={user}
            onChange={(e) => setUser(e.target.value)}
          />
          <TextField
            label="Password"
            variant="outlined"
            size="small"
            type="password"
            fullWidth
            sx={{ marginBottom: 2 }}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          {/* Validate Connection Button */}
          <Box sx={{ marginTop: 2, display: 'flex', justifyContent: 'flex-start' }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleValidateConnection}
              sx={{
                backgroundColor: 'white',
                color: 'black',
                border: '1px solid black',
                boxShadow: 'none',
              }}
            >
              Validate Connection
            </Button>
          </Box>
          {/* Connection Status */}
          {connectionStatus === 'success' && (
            <Typography sx={{ color: 'green', marginTop: 1, fontWeight: 'bold', whiteSpace: 'nowrap' }}>
              Target connection established successfully
            </Typography>
          )}
          {connectionStatus === 'failed' && (
            <Typography sx={{ color: 'red', marginTop: 1, fontWeight: 'bold', whiteSpace: 'nowrap' }}>
              Target connection failed, please review the inputs
            </Typography>
          )}

          {/* --- Add this block below connectionStatus --- */}
          {connectionStatus === 'success' && (
            <Box sx={{ marginTop: 2 }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 'bold', marginBottom: 1 }}>
                Please upload data insertion SQL
              </Typography>
              <Button
                variant="contained"
                color="primary"
                component="label"
                sx={{
                  backgroundColor: 'white',
                  color: 'black',
                  border: '1px solid black',
                  boxShadow: 'none',
                }}
              >
                Upload data inserted SQL
                <input
                  type="file"
                  hidden
                  onChange={handledatainsertionFileUpload}
                />
              </Button>
              {datainsertionsqlFileName && (
                <>
                  <Typography
                    variant="body2"
                    sx={{ marginTop: 1, color: 'green', fontWeight: 'bold' }}
                  >
                    Uploaded: {datainsertionsqlFileName}
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    sx={{ marginTop: 2, fontWeight: 'bold', whiteSpace: 'nowrap' }}
                  >
                    Please select the below option for creating data insertion
                  </Typography>
                  <RadioGroup
                    row
                    aria-label="data-insertion-method"
                    name="data-insertion-method"
                    sx={{ marginTop: 1 }}
                    value={dataInsertionMethod}
                    onChange={handleRadioChange}
                  >
                    <FormControlLabel
                      value="python"
                      control={<Radio />}
                      label="Python script"
                    />
                    <FormControlLabel
                      value="direct"
                      control={<Radio />}
                      label="Direct Database Insertion"
                    />
                  </RadioGroup>
                  {/* Show Data Insertion button only if a radio is selected */}
                  {dataInsertionMethod && (
                    <Button
                      variant="contained"
                      color="primary"
                      sx={{
                        marginTop: 2,
                        backgroundColor: 'white',
                        color: 'black',
                        border: '1px solid black',
                        boxShadow: 'none',
                      }}
                      onClick={handleDataInsertion}
                    >
                      {dataInsertionMethod === 'python' ? 'Submit' : 'Data Insertion'}
                    </Button>
                  )}
                </>
              )}
            </Box>
          )}
        </Box>
      )}

      {tabValue === 5 && (
        <Box sx={{ marginTop: 2 }}>
          <Box
            sx={{
              marginTop: 4,
              padding: '16px',
              backgroundColor: '#f9f9f9',
              borderRadius: '8px',
              border: '1px solid #ccc',
              marginBottom: 2,
            }}
          >
            <Typography variant="h6" sx={{ marginBottom: 2 }}>
              Result
            </Typography>
            <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace' }}>
              {datainsertionapiResult ? String(datainsertionapiResult.report) : 'No result available'}
            </Typography>
            
          </Box>
          {dataInsertionMethod === 'python' && datainsertionapiResult?.report && (
              <Button
                variant="contained"
                color="primary"
                startIcon={<ContentCopy />}
                onClick={() => {
                  navigator.clipboard.writeText(String(datainsertionapiResult.report));
                }}
                sx={{
                  backgroundColor: 'white',
                  color: 'black',
                  border: '1px solid black',
                  boxShadow: 'none',
                  marginTop: 1,
                }}
              >
                Copy Code
              </Button>
            )}
        </Box>
      )}

      {/* Spinner Modal */}
      <SpinnerModal
        open={spinnerMessages.open}
        progress={progress}
        inProgressMessage={spinnerMessages.inProgress}
        successMessage={spinnerMessages.success}
        onClose={spinnerMessages.onClose}
      />
    </Box>
  );
};

export default Nosql;